var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGasAndFuel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5927 13.3882L18.1631 12.2305C16.3785 10.7311 13.7185 10.9635 12.2199 12.75L8.10978 17.6685C7.94156 17.8684 7.97125 18.1644 8.16746 18.3286L9.60393 19.5339C9.80518 19.7027 10.1006 19.6719 10.264 19.4762L11.0601 18.5075L12.8009 19.969C13.8221 20.825 15.3271 20.7152 16.1572 19.7254L17.3624 18.289L19.7932 15.3923C20.2979 14.7907 20.1967 13.8949 19.5927 13.3882ZM15.4394 19.123C14.94 19.7167 14.0272 19.7735 13.4033 19.2507L11.6626 17.7897L12.5665 16.7124C12.8054 16.4282 13.1479 16.2583 13.531 16.2341C13.748 16.2239 13.9573 16.2593 14.154 16.3321C13.7489 16.9433 13.6679 17.7134 13.9819 18.4103C14.0878 18.6451 14.3638 18.7513 14.6022 18.6451C14.8379 18.5385 14.9432 18.2611 14.837 18.0248C14.6589 17.6297 14.7005 17.1966 14.923 16.8536L16.3435 18.0456L15.4394 19.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5852 18.5407L21.9771 15.7552C21.8933 15.6101 21.7386 15.5209 21.571 15.5209C21.4035 15.5209 21.2488 15.6101 21.165 15.7552L19.5216 18.6007C19.3289 18.9468 19.2273 19.3405 19.2273 19.7396C19.2273 21.0319 20.2788 22.0834 21.571 22.0834C22.8633 22.0834 23.9148 21.0319 23.9148 19.7396C23.9148 19.3176 23.8008 18.9028 23.5852 18.5407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7084 10.7721L22.2197 10.1642C20.9115 9.62995 19.4402 9.97923 18.5586 11.0303L18.3804 11.2426C18.5093 11.3322 18.6449 11.4111 18.7659 11.5127L20.1827 12.6594C20.3196 12.7743 20.4377 12.9029 20.5441 13.0389L20.7128 12.8379C20.8309 12.6951 21.0351 12.6503 21.2186 12.7263L22.7064 13.3333C22.9493 13.4334 23.2279 13.3114 23.3211 13.0668L23.9689 11.3736C24.06 11.1355 23.9441 10.8686 23.7084 10.7721Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGasAndFuel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gas_and_fuel.26a3866b4456f7fc2058428e669083f1.svg";